export default {"src":"/_next/static/media/kombucha-fallback.ea43f8b1.svg","height":320,"width":320};